import { defineMessages } from 'react-intl';

export default {
  default: defineMessages({
    postalCode: {
      id: 'address-fields.default.postal-code',
      defaultMessage: 'Postal Code',
    },
    address1: {
      id: 'address-fields.default.address1',
      defaultMessage: 'Address Line 1',
    },
    address1Sub: {
      id: 'address-fields.default.address1-sub',
      defaultMessage: 'Street Address, P.O. box etc',
    },
    address2: {
      id: 'address-fields.default.address2',
      defaultMessage: 'Address Line 2',
    },
    address2Sub: {
      id: 'address-fields.default.address2-sub',
      defaultMessage: 'Apartment, unit, suite, or floor #',
    },
    locality: {
      id: 'address-fields.default.locality',
      defaultMessage: 'City',
    },
    administrativeArea: {
      id: 'address-fields.default.administrativeArea',
      defaultMessage: 'State',
    },
  }),
  US: defineMessages({
    postalCode: {
      id: 'address-fields.us.postal-code',
      defaultMessage: 'ZIP Code',
    },
  }),
  GB: defineMessages({
    postalCode: {
      id: 'address-fields.gb.postal-code',
      defaultMessage: 'Postcode',
    },
    address2Sub: {
      id: 'address-fields.gb.address2-sub',
      defaultMessage: 'Flat, unit, suite, or floor #',
    },
    locality: {
      id: 'address-fields.gb.locality',
      defaultMessage: 'Town/City',
    },
    administrativeArea: {
      id: 'address-fields.gb.administrativeArea',
      defaultMessage: 'County',
    },
  }),
  CA: defineMessages({
    administrativeArea: {
      id: 'address-fields.ca.administrativeArea',
      defaultMessage: 'Province',
    },
  }),
};
